import React from "react";
import { Clock } from "lucide-react";
import { formatKdsTimer } from "@/lib/kdsTimer";
import { cn } from "@/lib/utils";

/**
 * Large elapsed timer for kitchen wall display (~1m readability).
 */
export default function KotTimerBadge({ seconds, urgencyTheme, className }) {
  return (
    <div
      className={cn(
        "inline-flex flex-col items-end gap-0.5 rounded-lg px-2.5 py-1.5 min-w-[88px]",
        urgencyTheme?.timerBg,
        className,
      )}
      data-testid="kds-timer-badge"
    >
      <div className="text-[9px] uppercase tracking-wider font-bold text-slate-500 flex items-center gap-1">
        <Clock size={10} />
        Elapsed
      </div>
      <div
        className={cn(
          "font-mono font-black tabular-nums leading-none tracking-tight",
          urgencyTheme?.timer,
          seconds >= 900 ? "text-[32px]" : seconds >= 600 ? "text-[28px]" : "text-[26px]",
        )}
      >
        {formatKdsTimer(seconds)}
      </div>
    </div>
  );
}
